import { Autocomplete, Box, Grid, TextField, Typography } from '@mui/material';
import React, { FC } from 'react';

interface ITenantAddDomainsProps {
	formik: any;
}

const TenantAddDomains: FC<ITenantAddDomainsProps> = ({ formik }) => (
	<Grid container>
		<Grid item xs={12}>
			<Typography variant="body1" color="textSecondary" mb={1}>
				{intl.tr('tenants.creation.dialog.sso.disclaimer')}
			</Typography>
			<Box flexDirection="row" display="flex" pb={1}>
				<Autocomplete
					data-testid="tenants-add-autocomplete"
					multiple
					filterSelectedOptions
					freeSolo
					autoSelect
					id="selfProvisioningDomains"
					value={formik.values.selfProvisioningDomains || []}
					options={formik.values.selfProvisioningDomains || []}
					renderInput={(params: any) => (
						<TextField
							{...params}
							placeholder={intl.tr(
								'tenants.creation.dialog.domains.placeholder'
							)}
							error={!!formik.errors.selfProvisioningDomains}
							helperText={formik.errors.selfProvisioningDomains}
						/>
					)}
					onChange={(_: any, v: any) => {
						if (v && Array.isArray(v)) {
							v.forEach((s, i) => {
								v![i] = s.replace('@', '');
							});
						}
						formik.setFieldValue('selfProvisioningDomains', v);
					}}
				/>
			</Box>
		</Grid>
	</Grid>
);

export default TenantAddDomains;
